import type { TFunction } from "i18next";
import { z } from "zod";

export const MAX_REJECT_DEFICIENCY_COMMENTS_LENGTH = 1000;

export const rejectDeficiencySchema = (t: TFunction) =>
  z.object({
    comments: z
      .string()
      .trim()
      .min(
        1,
        t("form-validation.mandatory", {
          label: t("deficiencies.decision-drawer.comments"),
        }),
      )
      .max(
        MAX_REJECT_DEFICIENCY_COMMENTS_LENGTH,
        t("form-validation.max-length", {
          label: t("deficiencies.decision-drawer.comments"),
          max: MAX_REJECT_DEFICIENCY_COMMENTS_LENGTH,
        }),
      ),
  });

export type RejectDeficiencyFormData = z.infer<ReturnType<typeof rejectDeficiencySchema>>;
